import { getMarket, selectionLabel } from '@h2h/shared';

export function legDetailText(
  marketId: string,
  selection: string,
  scorerName: string | undefined,
  home: string,
  away: string
): string {
  const m = getMarket(marketId);
  if (!m) return selection;
  if (m.kind === 'player') return scorerName ?? 'Scorer';
  if (m.kind === 'exact') return selection.replace('-', '–');
  return selectionLabel(marketId, selection, { home, away });
}
